import { useQuery } from '@tanstack/react-query';
import { resolveUsers } from '@/services/api/endpoints';

// Resolve one Entra oid -> display name (Graph), for the "filed by" tooltip on
// mails whose filed_by_name wasn't captured at filing time. `enabled` gates it
// to hover so a long list doesn't fan out Graph calls. Cached for an hour.
export function useResolveUser(oid: string | null | undefined, enabled: boolean) {
  return useQuery<string | null>({
    queryKey: ['user-name', oid],
    queryFn: async () => (oid ? (await resolveUsers([oid]))[oid] ?? null : null),
    enabled: Boolean(oid) && enabled,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });
}
